export default function AttachmentIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3333 4.99999L6.32161 12.155C6.00898 12.4676 5.83335 12.8916 5.83335 13.3337C5.83335 13.7759 6.00898 14.1999 6.32161 14.5125C6.63423 14.8251 7.05824 15.0007 7.50036 15.0007C7.94247 15.0007 8.36648 14.8251 8.67911 14.5125L15.6908 7.35749C16.3159 6.73236 16.6671 5.88449 16.6671 5.00041C16.6671 4.11633 16.3159 3.26847 15.6908 2.64333C15.0656 2.01819 14.2178 1.66699 13.3337 1.66699C12.4496 1.66699 11.6017 2.01819 10.9766 2.64333L3.99411 9.76916C3.52361 10.2321 3.14941 10.7835 2.89311 11.3918C2.6368 12 2.50346 12.653 2.50077 13.313C2.49809 13.973 2.62611 14.6271 2.87745 15.2374C3.12879 15.8477 3.49848 16.4022 3.9652 16.8689C4.43191 17.3356 4.98642 17.7053 5.59672 17.9567C6.20703 18.208 6.86106 18.336 7.52109 18.3333C8.18112 18.3306 8.83409 18.1973 9.44233 17.941C10.0506 17.6847 10.602 17.3105 11.0649 16.84L18.0474 9.71416"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
